import { PlanogramItem, PlanogramItemOrientation } from "@CommonTypes/merchflow/pog/item";
import { SelectOption } from "src/elements/Select/store/types";
import { Color } from "src/elements";

export const PLANOGRAM_ORIENTATION_MIXED = "OPTION_MIXED" as const;

export const planogramOrientationOptions = [
  { label: "FRONT", value: "FRONT" },
  { label: "FRONT2", value: "FRONT2" },
  { label: "SIDE", value: "SIDE" },
  { label: "SIDE2", value: "SIDE2" },
  { label: "TOP", value: "TOP" },
  { label: "TOP2", value: "TOP2" },
] satisfies SelectOption<PlanogramItemOrientation>[];

export type PlanogramOrientationSelectValue =
  | PlanogramItemOrientation
  | typeof PLANOGRAM_ORIENTATION_MIXED;

export interface PlanogramOrientationSelectState {
  selectedOrientation: PlanogramItemOrientation | null;
  isMixed: boolean;
  isDisabled: boolean;
  value: PlanogramOrientationSelectValue;
  options: SelectOption<PlanogramOrientationSelectValue>[];
}

export const canSetPlanogramItemOrientation = (
  selectedItems: PlanogramItem[],
  orientation: PlanogramItemOrientation,
) => selectedItems.every((item) => item.validOrientations.includes(orientation));

export const getCappingOrientationOptions = (mainOrientation: PlanogramItemOrientation) =>
  planogramOrientationOptions.filter((option) => option.value !== mainOrientation);

export const getPlanogramOrientationSelectState = (
  selectedItems: PlanogramItem[],
): PlanogramOrientationSelectState => {
  if (selectedItems.length === 0) {
    return {
      selectedOrientation: null,
      isMixed: false,
      isDisabled: true,
      value: PLANOGRAM_ORIENTATION_MIXED,
      options: [],
    };
  }

  const selectedOrientation = selectedItems[0]?.orientation ?? null;
  const isMixed = selectedItems.some((item) => item.orientation !== selectedOrientation);
  const invalidOrientationIcon = { name: "warningCircle", color: Color.warningIcon } as const;
  const orientationOptions = planogramOrientationOptions.map((option) => ({
    ...option,
    isDisabled: false,
    ...(canSetPlanogramItemOrientation(selectedItems, option.value)
      ? {}
      : { icon: invalidOrientationIcon }),
  }));

  return {
    selectedOrientation: isMixed ? null : selectedOrientation,
    isMixed,
    isDisabled: false,
    value: isMixed
      ? PLANOGRAM_ORIENTATION_MIXED
      : (selectedOrientation ?? PLANOGRAM_ORIENTATION_MIXED),
    options: [
      ...orientationOptions,
      ...(isMixed
        ? [
            {
              label: "MIXED VALUES",
              value: PLANOGRAM_ORIENTATION_MIXED,
              isDisabled: true,
            },
          ]
        : []),
    ],
  };
};
